"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _fp = _interopRequireDefault(require("lodash/fp"));

var _reactRouterDom = require("react-router-dom");

var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));

var _ListItemIcon = _interopRequireDefault(require("@material-ui/core/ListItemIcon"));

var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

var _colors = _interopRequireDefault(require("@fe/ui/colors"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var DrawerLink = function DrawerLink(props) {
  var isExternal = !_fp.default.flow(_fp.default.get('href'), _fp.default.isEmpty)(props);

  var LinkItem = /*#__PURE__*/_react.default.createElement(_ListItem.default, {
    button: true,
    style: {
      backgroundColor: props.active ? _colors.default.paleBlue : _colors.default.white
    }
  }, props.icon && /*#__PURE__*/_react.default.createElement(_ListItemIcon.default, null, props.icon), /*#__PURE__*/_react.default.createElement(_ListItemText.default, {
    classes: props.classes,
    inset: !props.icon,
    primary: props.name,
    primaryTypographyProps: {
      variant: 'subtitle1'
    }
  }), Boolean(props.rightIcon) && props.rightIcon); // The NavLink component cannot open external urls, and since we need that for support links
  // this component can now return the link text/icon wrapped in an <a/>


  if (isExternal) {
    return /*#__PURE__*/_react.default.createElement("a", {
      target: "_blank",
      style: {
        textDecoration: 'none',
        color: _colors.default.pieNormalBlue
      },
      href: props.href
    }, LinkItem);
  } else {
    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.NavLink, {
      onClick: props.onClick,
      exact: true,
      style: {
        textDecoration: 'none',
        color: _colors.default.pieNormalBlue
      },
      to: props.to
    }, LinkItem);
  }
};

DrawerLink.propTypes = {
  name: _propTypes.default.string.isRequired,
  icon: _propTypes.default.node,
  to: _propTypes.default.string,
  href: _propTypes.default.string,
  active: _propTypes.default.bool
};

var _default = (0, _withStyles.default)(function (theme) {
  return {
    primary: {
      color: theme.palette.text.primary
    }
  };
})(DrawerLink);

exports.default = _default;